<div
  #listRef="cdkDropList"
  cdkDropList
  [cdkDropListData]="elements"
  class="rank-list"
  (cdkDropListDropped)="drop($event)"
>
  @for (element of elements; track element; let i = $index) {
    <div class="rank-el" cdkDrag>
      <div class="text-wrapper">
        <div class="dots">
          <div class="dot left top"></div>
          <div class="dot left mid"></div>
          <div class="dot left bot"></div>
          <div class="dot right top"></div>
          <div class="dot right mid"></div>
          <div class="dot right bot"></div>
        </div>
        {{ element.label }}
      </div>
      <div class="button-wrapper">
        <button (click)="moveUp(i)">
          <span class="arrow down" inlineSVG="/icons/icon-chevron-arrow.svg"></span>
        </button>
        <button (click)="moveDown(i)">
          <span class="arrow up" inlineSVG="/icons/icon-chevron-arrow.svg"></span>
        </button>
      </div>
    </div>
  }
</div>
